import React from 'react';
import {get} from 'lodash';
import {gql} from 'apollo-boost';

import client from '../../../src/graphql/client';

import refactorHb from '../../../src/data-restructure/multimedia/hero-banner';
import respImgQuery from '../../../src/graphql/queries/resp-img';
import refactorRespImg from '../../../src/data-restructure/ui/resp-img';
import seoQuery from '../../../src/graphql/queries/seo';

import ModelBeginPage from '../../../src/containers/ModelBeginPage';


const BuildPriceSeries = (props) => {
  return (
    <ModelBeginPage
      {...props}
    />
  )
}


export async function getStaticPaths() {

  const GET_DYNAMIC_PATHS_QUERY = gql`
    query GET_DYNAMIC_PATHS {
      series(where: {status: PUBLISH}, first: 1000) {
        nodes {
          uri
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  const series = get(result, 'data.series.nodes', []);
  let paths = [];
  
  const filteredSeries = series.filter((item) => {
    // filter out if doesn't have uri
    return item.uri
  });
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  filteredSeries.forEach(series => {
    const assignedDomains = get(series, 'acf_domains.assignedDomains', []);
    assignedDomains.indexOf(domain) !== -1 && series.uri != 'new-models' && paths.push({
      params: {
        series: `${series.uri}`
      }
    });
  })

  return { paths , fallback: false }
}


export async function getStaticProps(context) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const {
    params
  } = context
  
  const GET_DYNAMIC_SERIES_PROPS = gql`
    query GET_SERIES_DATA($uri: String) {
        seriesBy(uri: $uri) {
          id
          title
          link
          seo {
            ${seoQuery}
          }
          acf_domains {
            assignedDomains
          }
          acf_series_v2 {
            sv2HeroBanner {
              subtitle
              text
            }
            sv2SubnavLogo {
              ${respImgQuery}
            }
            sv2SubnavColour
          }
          acf_series {
            seriesImage {
              ${respImgQuery}
            }
            seriesSpecsRep {
              seriesSpecRepTitle
            }
            seriesDisclaimer {
              ... on Disclaimer {
                acf_disclaimer {
                  disclaimerText
                }
              }
            }
          }
        }
        dealers(first: 1000) {
          nodes {
            uri
            title
            acf_dealers {
              addressLine1
              country
              website
              suburb
              state
              sales
              postcode
              postcodes
              phone
              latitude
              longitude
            }
          }
        }
        pageBy(uri: "build-price") {
          acf_build_and_price {
            bptHidePrice
          }
        }
    }
  `
  const gqData = await client.query({
    query: GET_DYNAMIC_SERIES_PROPS,
    variables: {
      uri: params.series
    }
  });
  
  //console.log('gqSData>>>>', gqData);

  // Get all dealers with sales == 1
  var dealers = [];
  get(gqData, 'data.dealers.nodes', []).map(dItem => {
    if (get(dItem, 'acf_dealers.sales', null) == '1') {
        dealers.push({
            "title": dItem.title,
            "uri": dItem.uri,
            "acf_dealers": {
                "addressLine1": get(dItem, 'acf_dealers.addressLine1', null),
                "country": get(dItem, 'acf_dealers.country', null),
                "dealerID": get(dItem, 'acf_dealers.dealerID', null),
                "latitude": get(dItem, 'acf_dealers.latitude', null),
                "longitude": get(dItem, 'acf_dealers.longitude', null),
                "phone": get(dItem, 'acf_dealers.phone', null),
                "postcode": get(dItem, 'acf_dealers.postcode', null),
                "postcodes": get(dItem, 'acf_dealers.postcodes', null),
                "sales": get(dItem, 'acf_dealers.sales', null),
                "state": get(dItem, 'acf_dealers.state', null),
                "website": get(dItem, 'acf_dealers.website', null),
                "suburb": get(dItem, 'acf_dealers.suburb', null),
            }
        });
    }
  });
  /////////////////////////////////////
  
  var modelFooter = {
        text: ''
  }
  var disclaimers = get(gqData, 'data.seriesBy.acf_series.seriesDisclaimer', null);
  if (disclaimers) {
    disclaimers.map(item=>{
      var dText = get(item, 'acf_disclaimer.disclaimerText', null);
      if (dText) {
        modelFooter.text = modelFooter.text + dText;
      }
    });
  }

  const data = {
    seriesName: get(gqData, 'data.seriesBy.title', null),
    seriesUrl: {
        link: {
            "title": get(gqData, 'data.seriesBy.title', null),
            "href": `/build-price/${params.series}`,
            "target": "",
            "assignedDomains": get(gqData, 'data.seriesBy.acf_domains.assignedDomains', null),
        }
    },
    disablePrice: get(gqData, 'data.pageBy.acf_build_and_price.bptHidePrice', null),
    modelsCount: gqData.data.seriesBy.acf_series.seriesSpecsRep.length,
    seriesParams: params.series,
    dealers,
    modelImageText: {
        headline: get(gqData, 'data.seriesBy.acf_series_v2.sv2HeroBanner.subtitle', null),
        introText: get(gqData, 'data.seriesBy.acf_series_v2.sv2HeroBanner.text', null),
        image: get(gqData, 'data.seriesBy.acf_series.seriesImage', null) ?
            refactorRespImg(get(gqData, 'data.seriesBy.acf_series.seriesImage', null), [{
            size: 'default',
            key: 'image_size_704x514',
          },{
            size: 'md',
            key: 'image_size_960x514',
          }]): null,
    },
    modelLogo: {
        bgColour: get(gqData, 'data.seriesBy.acf_series_v2.sv2SubnavColour', null),
        logo: get(gqData, 'data.seriesBy.acf_series_v2.sv2SubnavLogo', null) ?
            refactorRespImg(get(gqData, 'data.seriesBy.acf_series_v2.sv2SubnavLogo', null), [{
            size: 'default',
            key: 'image_size_320x38',
          },{
            size: 'md',
            key: 'image_size_320x38',
          }]): null,
    },
    modelFooter,
    modelName: null,
    modelUrl: null,
    countryProps: {}
  }

  return {
    props: {
      ...data,
      greyBg: true
    }
  }
}


export default BuildPriceSeries
  
